import React from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { AppShell } from './layouts/AppShell';
import { AdminInviteAcceptance } from './pages/auth/AdminInviteAcceptance';

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

function AppContent() {
  const location = useLocation();
  return location.pathname === '/admin-invite' ? <AdminInviteAcceptance /> : <AppShell />;
}

export default App;
